/** Short hint when the empty paragraph is focused (Preview). */
export const RICH_TEXT_FOCUSED_PLACEHOLDER = "Type '/' for commands…"

/** Markdown mode empty textarea. */
export const RICH_TEXT_MARKDOWN_PLACEHOLDER =
  'Write markdown here (# headings, **bold**, - lists).'
